import { ChargePoint, ResponseGetChargePoint } from '../../app/ApiGen';
import { normalise, Normalised, request } from '../../utils/request';

export const getChargePoint: (id: string) => Promise<Normalised<ChargePoint>> = async (id: string) => {
  const response = await request<ResponseGetChargePoint>(`/charge-points/${id}`, { method: 'GET' });
  return normalise(response);
};
